import sort from 'array-sort';

/**
 * The account's alerts, as a sorted array or an id-keyed map.
 *
 * `useCache` defaults to **off**, and deliberately so. `window.userAlerts` is
 * written on every call but nothing invalidates it, and the alerts page reloads
 * the list on `alert/created` / `alert/updated` and after a delete or pause — so
 * a cache that is on by default would show that page a stale list immediately
 * after every edit. Callers that know the data cannot have changed underneath
 * them (one render pass reading the list more than once) can opt in.
 *
 * @param {boolean} returnArr true for a sorted array, false for an id-keyed map
 * @param {boolean} useCache  reuse this page's already-fetched alerts
 */
const getAlerts = async (returnArr = true, useCache = false) => {
  let alertsData;

  if (window.userAlerts && useCache) {
    alertsData = window.userAlerts;
  } else {

    const r = await window.apiRequest('get', '/alerts/all');

    if (r.type !== 'success') {
      throw new Error('API call unsuccessful');
    }

    alertsData = r.data;

    // Cache the alerts for subsequent calls in this page
    window.userAlerts = alertsData;

  }

  // Process the alerts based on the returnArr flag
  if (returnArr) {
    return sort(alertsData, 'alert_name');
  } else {
    const alerts = {};
    alertsData.forEach(alert => {
      alerts[alert.id] = alert;
    });
    return alerts;
  }

};

export default getAlerts;
